export const mutationCreateComment = /* GraphQL */ `
  mutation CreateComment($input: CreateCommentInternalInput!) {
    createComment(input: $input) {
      edge {
        node {
          id
          body
          createdAt
          replies {
            edges {
              node {
                id
                body
                createdAt
                replyCount
              }
            }
          }
          replyCount
        }
      }
    }
  }
`;

export const queryGetComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    coralcomment(id: $id) {
      revisions {
        id
        body
        isAnonymous
        meta {
          createdBy {
            id
            name
            username
            email
          }
        }
      }
    }
  }
`;

export const queryGetComments = /* GraphQL */ `
  query GetComments(
    $first: Int = 10
    $after: Cursor
    $submissionID: ID
    $siteID: ID
    $showPrimaryComments: Boolean
    $status: COMMENT_STATUS
    $section: SectionFilter
    $query: String
    $orderBy: COMMENT_SORT
  ) {
    coralcomments(
      first: $first
      after: $after
      submissionID: $submissionID
      siteID: $siteID
      showPrimaryComments: $showPrimaryComments
      status: $status
      section: $section
      query: $query
      orderBy: $orderBy
    ) {
      id
      createdAt
      parentID
      parentRevisionID
      status
      rating
      revisions {
        id
        body
        isAnonymous
        meta {
          createdBy {
            name
            username
            id
            email
          }
        }
        createdAt
      }
      childCount
    }
  }
`;

export const mutationEditComment = /* GraphQL */ `
  mutation EditComment($input: EditCommentInputInternal!) {
    editComment(input: $input) {
      comment {
        id
        body
        createdAt
        parent {
          id
        }
        replies {
          edges {
            node {
              id
              body
              createdAt
              replyCount
            }
          }
        }
        replyCount
      }
    }
  }
`;

export const mutationReplyComment = /* GraphQL */ `
  mutation ReplyComment($input: CreateCommentReplyInputInternal!) {
    createCommentReply(input: $input) {
      id
      createdAt
      parentID
      parentRevisionID
      revisions {
        id
        body
        isAnonymous
        meta {
          createdBy {
            name
            username
            id
            email
          }
        }
        createdAt
      }
      childCount
    }
  }
`;
